"use strict";
exports.__esModule = true;
exports.EMBED_AUTOPAY = void 0;
exports.EMBED_AUTOPAY = {
    HEADER: 'Flex rent autopay',
    BODY_AUTOPAY: 'Rent autopay is on. Your payments will be processed automatically each month based on your payment schedule. You can adjust this any time in the Flex app.',
    BODY_EPISODIC: 'Rent autopay is off. You can control when to initiate Flex each month or skip a month. You have the option to manually initiate Flex from your rent portal or the Flex app.'
};
